import { getModelById } from './model-registry';
/**
 * 定義がない（または能力情報を持たない）Bedrock モデル向けの安全側の既定値。
 * 推論パラメータ・明示キャッシュを付けず、最大出力は上限超過を起こさない 32768 に抑える。
 * 文書入力・ツール結果の画像は既存の添付挙動を変えないため許可とする。
 */
export const DEFAULT_BEDROCK_CAPABILITIES = {
    reasoning: { kind: 'none' },
    supportsExplicitPromptCache: false,
    maxOutputTokens: 32_768,
    supportsDocumentInput: true,
    acceptsPriorReasoning: true,
    supportsToolResultImage: true,
};
/**
 * Bedrock モデルの能力情報を既定値つきで返す。
 *
 * @param modelId - resolveModelId で解決済みの具体的モデルID
 */
export function getBedrockCapabilities(modelId) {
    const capabilities = getModelById(modelId, 'bedrock')?.capabilities;
    if (capabilities) {
        return capabilities;
    }
    console.warn(`[model-capabilities] No capabilities defined for bedrock model "${modelId}"; using safe defaults.`);
    return DEFAULT_BEDROCK_CAPABILITIES;
}
//# sourceMappingURL=model-capabilities.js.map